import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Canonical shadcn/ui helper: merges conditional class names, then resolves Tailwind conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
